module.exports = __webpack_public_path__ + "static/media/motorcycle.063d4b32.svg";